module.exports = __webpack_public_path__ + "img/index-shop.e9e58000.jpg";